import { render, staticRenderFns } from "./abstract-list.vue?vue&type=template&id=469240a8&scoped=true"
import script from "./abstract-list.vue?vue&type=script&lang=js"
export * from "./abstract-list.vue?vue&type=script&lang=js"
import style0 from "./abstract-list.vue?vue&type=style&index=0&id=469240a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469240a8",
  null
  
)

export default component.exports